import { createContext } from 'react';

/**
 * The currency of the RECORD a subtree is showing — see `<MoneyCurrency>`.
 * `null` means "no record override": the scope currency applies.
 */
export const MoneyCurrencyContext = createContext<string | null>(null);
